import { ValueFormatterParams } from "ag-grid-community";
import { MetricsValueFormatterOptions } from "./metrics-formatter-helper";
import { formatThousands } from "lib/number";

export const metricsNumberFormatter = (options: MetricsValueFormatterOptions) => {
    return (params: ValueFormatterParams | number) => {
        const { numberFormat } = options;
        let currentValue: any;
        // Have rewritten this function to accept either a number or a object param with param.value
        // In this way this method can be reused in other places too
        if (typeof params === "object" && "value" in params && !isNaN(params.value)) {
            currentValue = Number(params.value);
        } else if (typeof params === "number") {
            currentValue = params;
        }

        if (!isNaN(currentValue) && currentValue !== undefined) {
            if (!numberFormat) {
                return `${currentValue}`;
            } else if (numberFormat.percentage) {
                const { decimal_places } = numberFormat.percentage;
                return `${formatThousands(currentValue.toFixed(decimal_places))}%`;
            } else if (numberFormat.currency) {
                const { symbol, decimal_places } = numberFormat.currency;
                return `${symbol}${formatThousands(currentValue.toFixed(decimal_places))}`;
            }
        }

        return undefined;
    };
};
